<template>
  <div>
    <search placeholder="请输入食物名称"
      v-model="search.key"
      hide
      @search="handleSearch"></search>
    <div class="eating-home"
      v-if="list.length">
      <div class="eating-home-list">
        <div class="eating-home-list-item"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)">
          <img :src="item.icon"
            alt="icon.png">
          <p>{{item.category_name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeList } from './api/index'
import Search from './components/Search'
import { isWeixin, appShare } from '@/helpers';
import store from '@/store.js'

export default {
  name: 'EatingHome',
  components: {
    Search
  },
  data () {
    return {
      list: [],
      search: {
        key: ''
      }
    }
  },
  computed: {
    isWeixin () {
      return isWeixin()
    }
  },
  created () {
    this.fetchData()
    // app分享
    setTimeout(() => {
      appShare({
        title: '能不能吃',
        link: window.location.href,
        imgUrl: 'http://101file.doctopia.com.cn/1574328236764Fda89LMT4oNa8BpcNirDPAel.png',
        desc: '快速查询工具，妈妈宝宝在孕育阶段能不能吃的大全页'
      })
    }, 1000)
  },
  mounted () {
    document.title = '能不能吃'
  },
  methods: {
    fetchData () {
      getHomeList()
        .then(res => {
          this.list = res.data.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    goDetail (item) {
      this.$router.push({
        path: `/eating/list?id=${item.id}`
      })
    },
    handleSearch (val) {
      if (val.trim() === '') return false
      this.$router.push({
        path: `/eating/list?search=${val}`
      })
    }
  }
}
</script>

<style lang="scss">
.eating-home {
  @function pxTOvw($px) {
    @return $px / 2.3;
  }
  padding-top: pxTOvw(30px);
  overflow: hidden;
  &-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &-item {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: pxTOvw(40px);

      img {
        width: pxTOvw(120px);
        height: pxTOvw(120px);
      }

      p {
        margin: 0;
        font-size: pxTOvw(28px);
        color: #60594e;
        margin-top: pxTOvw(20px);
      }
    }
  }

  &-tip {
    margin-top: pxTOvw(30px);
    text-align: center;
    font-size: pxTOvw(34px);
    color: rgba(51, 51, 51, 1);
  }

  &-ask {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0 none;
    background-color: rgba(57, 181, 74, 1);
    line-height: pxTOvw(77px);
    border-radius: pxTOvw(11px);
    color: #fff;
    width: pxTOvw(396px);
    text-align: center;
    font-weight: bold;
    font-size: pxTOvw(32px);
    margin: 0 auto;
    margin-top: pxTOvw(20px);
    margin-bottom: pxTOvw(20px);
  }
}
</style>
